import React from "react";
import { BaseIconProps } from "../../types/styles";

const CheckIcon = ({
    id,
    className,
    size = 26,
    customColor,
    ...rest
}: BaseIconProps) => {
    const color = customColor ?? "var(--neutral-500)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-check"}
            className={className}
            height={size}
            width={size}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 26 26"
        >
            <path
                d="M19.4227 6.91513C19.7483 6.58949 20.2763 6.58949 20.6019 6.91513C20.9276 7.24077 20.9276 7.76874 20.6019 8.09438L10.5957 18.1006C10.27 18.4263 9.74207 18.4263 9.41643 18.1006L5.24716 13.9314C4.92152 13.6057 4.92152 13.0777 5.24716 12.7521C5.5728 12.4265 6.10077 12.4265 6.42641 12.7521L10.0061 16.3318L19.4227 6.91513Z"
                fill={color}
            />
        </svg>
    );
};

export default CheckIcon;
